import { StateParams, StateService } from "@uirouter/angularjs";
import { IOnInit, ICompileService } from "angular";
import { RecordDataSource } from "../../../records/grids";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import { IQuery } from "../../../records/server/query";
import {
  GridConfiguration,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../records/views/recordGridView";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../app/records/server/serverUtility";
import {
  ContractService,
  IContractType,
  vsServiceName as ContractServiceName,
  ContractTypeService,
} from "../../../Contract/shared/ContractService";
import "angular-formly";
const gridId = Symbol("main.contract.gamingRelationship");
export class GamingRelationshipGridController implements IOnInit {
  static $inject = [
    "$stateParams",
    "slotTrakMachinesServer",
    serverUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    RecordGridViewServiceName,
    "$compile",
    ContractServiceName,
    "$state",
  ];
  gridDataSource!: RecordDataSource;
  readonly gridSettings: IGridSettings;
  readonly columns: ColDef[];
  readonly defaultQuery: IQuery = {};
  contractInstances!: any;
  instancesId: string = "";
  dropdownOptions: IContractType[] = [];
  contract!: any;
  contractType!: ContractTypeService;
  totalCount: number = 0;

  constructor(
    public readonly $stateParams: StateParams,
    public readonly slotTrakMachinesServer: any,
    public readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    columnDefinitionService: ColumnDefinitionService,
    private readonly recordGridViewService: RecordGridViewService,
    $compile: ICompileService,
    private contractService: ContractService,
    private readonly $state: StateService
  ) {
    
    this.gridSettings = gridSettingsService.getGridSettings(gridId);

    this.columns = [
      columnDefinitionService.getCommandColDef({
        headerName: "delete",
        name: "delete",
        iconClass: "fa fa-trash text-primary",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "Id",
        header: "Id",
      }),
      columnDefinitionService.getStringColDef({
        field: "RelationshipType",
        header: "Type",
      }),
      columnDefinitionService.getStringColDef({
        field: "Role",
        header: "Relationship Role",
      }),
      columnDefinitionService.getNumberColDef({
        field: "ContractInstanceId",
        header: "Related With",
      }),
      
    ];
  }

  $onInit(): void {
    this.defaultQuery.ContractType = this.contractType.id

    this.gridDataSource = new RecordDataSource(
      this.serverUtility,
      `/api/contract/contractRelationshipLog/${this.contract.ContractInstanceId}`
    );
    
    this.loadContractTypes();
  }
  loadContractTypes(): void {
    this.dropdownOptions = this.contractService.getContractTypes();
  }
  addContract(contractType: IContractType) {
    this.$state.go("main.contract.type.create", { type: contractType.id });
  }
}
